
import { Options, Vue } from 'vue-class-component'
import * as ticketApi from '@/api/ticket'
import { deepCopy, checkImage } from '@/utils/utils'
import TemplateGenerator from '@/components/TemplateMaking/TemplateGenerator.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import TicketAddTag from '@/components/TicketAddTag.vue'
import * as label from '@/api/label'
import * as agent from '@/api/agent'
import { uploadFile } from '@/api/files'
import { ElMessage, ElLoading, ElMessageBox } from 'element-plus'
import { TicketStatus, putMilestoneTime, putProblemCreatetime, putTicketCreatetime, putTransactiontime } from '@/api/ticket'
import { postJira, getJiraProjectAndErrorEnv, agentsForJira, ticketRelationJira } from '@/api/problem'
import store from '@/store'
import TinymceEditor from '@/components/TinymceEditor.vue'
import TicketTemplateChange from '@/components/TicketTemplateChange.vue'
import { selfTags } from '@/api/label'
@Options({
  name: 'TicketDetail',
  components: {
    Breadcrumb,
    TicketAddTag,
    TemplateGenerator,
    TinymceEditor,
    TicketTemplateChange,
  }
})
export default class TicketDetail extends Vue {
  me = store.getters['auth/me']
  showUploadFileList = false
  showTicketAddTag = false
  processLabels:Array<any> = []
  handlers :Array<any> = []
  tableData = []
  userName = ''
  contJiraType = ''
  ticket :Record<string, any> = {}
  currentTemplateInfo :Record<string, any> = {}
  template = {}
  transactions = [] as any
  templateUsedRecord = []
  templateValue = {}
  uploading = false
  detialShowTickets = false
  relationJiraBtn = false
  showChangeTemplate = false
  problemId = null
  fileList: Array<any> = []
  selfTagList: Array<string> = []
  extraTags: Array<any> = []
  jiraProject = null
  jiraProjectList = []
  errorEnvList = []
  errorEnv = null
  jiraHandlers :Array<any> = []
  handlerJira = null
  workflowId = null
  workflowName = null
  workflowDiagram = ''
  workflowDiagramList :Array<any> = []
  previewDialogVisible = false
  milestoneList :Array<any> = []
  claimablePhases: Array<any> = []
  processablePhases: Array<any> = []
  showPhaseSelectDialog = false
  selectedPhase = ''
  startPlanTime = null
  endPlanTime = null
  ruleForm = {
    nextProcess: null,
    nextHandler: null,
    newReply: '',
  }

  planTime = {
    start: null,
    end: null
  }

  problemCreateTime = null
  ticketCreateTime = null
  transactions2 = [] as any

  taskVariables :Record<string, any> = {}

  async updateProblemCreateTime () {
    const id = Number(this.$route.params.id)
    try {
      console.log(this.problemCreateTime)
      const createdAt = this.problemCreateTime ? Math.floor((new Date(this.problemCreateTime || new Date()).getTime() / 1000)) : null
      await putProblemCreatetime(id, { created_at: createdAt })
      ElMessage({
        message: '更新问题创建时间成功',
        type: 'success'
      })
      this.ticket.fields.problem.fields.createTime = createdAt
    } catch (e:any) {
      ElMessage({
        message: '更改问题创建时间失败' + e.errmsg,
        type: 'error'
      })
    }
  }

  async updateTicketCreateTime () {
    const id = Number(this.$route.params.id)
    try {
      console.log(this.ticketCreateTime)
      const createdAt = this.ticketCreateTime ? Math.floor((new Date(this.ticketCreateTime || new Date()).getTime() / 1000)) : null
      await putTicketCreatetime(id, { created_at: createdAt })
      ElMessage({
        message: '更新工单创建时间成功',
        type: 'success'
      })
      this.ticket.fields.createdAt = createdAt
    } catch (e:any) {
      ElMessage({
        message: '更改工单创建时间失败' + e.errmsg,
        type: 'error'
      })
    }
  }

  async updateTxTime (txId: any, index: any) {
    const id = Number(this.$route.params.id)
    try {
      console.log('txId=')
      console.log(txId)
      console.log('index=')
      console.log(index)
      let createdAt = this.transactions2[index].createdAt
      createdAt = createdAt ? Math.floor((new Date(createdAt || new Date()).getTime() / 1000)) : null
      await putTransactiontime(id, { transaction_id: txId, created_at: createdAt })
      ElMessage({
        message: '更新工单任务时间成功',
        type: 'success'
      })
      this.transactions[index + 1].createdAt = createdAt
    } catch (e:any) {
      ElMessage({
        message: '更改工单任务时间失败' + e.errmsg,
        type: 'error'
      })
    }
  }

  handlePhaseChange (phaseId: any) {
    this.taskVariables = { ...(this.processablePhases.find(v => v.phaseId === phaseId)?.taskVariables || {}) }
  }

  async upMilestoneTime (val:any) {
    const id = Number(this.$route.params.id)
    const projectTime :any = {
      start: this.planTime?.start ? Math.floor((new Date(this.planTime?.start || new Date()).getTime() / 1000)) : null,
      end: this.planTime.end ? Math.floor((new Date(this.planTime?.end || new Date()).getTime() / 1000)) : null,
    }
    const obj = this.milestoneList?.map(i => ({ ...i, time: i.time ? Math.floor((new Date(i.time).getTime()) / 1000) : null }))
    try {
      await putMilestoneTime(id, { wfPlan: projectTime, wfMilestone: obj })
      ElMessage({
        message: '更新时间成功',
        type: 'success'
      })
    } catch (e:any) {
      ElMessage({
        message: '更改时间失败' + e.errmsg,
        type: 'error'
      })
    }
  }

  nextProcessValidator = (rule: any, value: any, callback: (arg0: Error | undefined) => void) => {
    console.log('nextProcessValidator')
    console.log('this.buttonClicked：', this.buttonClicked)
    if (this.buttonClicked === 'continue' && !this.workflowId) {
      if (!value) {
        callback(new Error('请选择下一阶段'))
      } else {
        // callback()
      }
    } else {
      // callback()
    }
  }

  rules = {
    nextProcess: [
      {
        validator: this.nextProcessValidator,
        trigger: 'blur'
      }
    ],
    newReply: [
      {
        required: true,
        message: '请填写问题回复',
        trigger: 'blur'
      },
      {
        min: 1,
        message: '请填写问题回复',
        trigger: 'blur'
      },
    ],
  }

  buttonClicked = ''

  get isFinish () {
    if (this.ticket.fields?.curPhaseId) {
      return this.ticket.fields?.curStatus === 'closed'
    }
    return false
  }

  get isClaimable () {
    if (this.ticket.fields?.curPhaseId) {
      return this.ticket.fields?.curStatus === 'unassigned' && this.selfTagList?.includes(this.getLevel())
    }
    return this.processablePhases?.length <= 0 && this.claimablePhases.length > 0
  }

  get isHandleable () {
    if (this.ticket.fields?.curPhaseId) {
      return this.ticket.fields?.curStatus !== 'closed' && this.ticket.fields?.responsibleAgent === this.me.ldap
    }
    return this.processablePhases?.length > 0
  }

  get isEditable () {
    return this.ticket.fields?.curStatus === 'unassigned' && this.ticket.fields?.creator === this.me.ldap
  }

  get isDirectClosable () {
    return this.ticket.fields?.curStatus !== 'closed' && this.ticket.fields?.creator === this.me.ldap
  }

  get ticketDesc () {
    if (this.transactions.length > 0) {
      return this.transactions[0]
    }
    return null
  }

  get jiraButtonDiasable () {
    return (!this.jiraProject || !this.errorEnv) && this.detialShowTickets
  }

  get workFlowCurrentStatus () {
    type nodeType = {node: string, name: string}
    const status:nodeType[] = []
    if (this.ticket?.fields?.curPhases.length > 0) {
      this.ticket.fields.curPhases.forEach((item: { phaseName: any; claimable: any[] }) => {
        status.push({ node: item.phaseName, name: '可认领人：' + item.claimable?.join(',') })
      })
    }
    return status
  }

  get jiraButtonDiasable2 () {
    return (!this.jiraProject || !this.errorEnv || !this.handlerJira) && this.detialShowTickets
  }

  getLevel = () =>
    this.processLabels?.find((label) => label.id === this.ticket?.fields?.curPhaseId)?.name

  assignMe () {
    if (this.ticket.fields?.curPhaseId) {
      return this.ticketClickAssignMe()
    } else if (this.claimablePhases?.length > 1) {
      this.showPhaseSelectDialog = true
      this.selectedPhase = ''
    } else {
      this.ticketClickAssignMeWithPhaseId(this.claimablePhases?.[0]?.phaseId)
    }
  }

  restartTicket () {
    const loadingInstance = ElLoading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading'
    })
    ticketApi.ticketRestart(this.ticket.pk).then(() => {
      ElMessage({
        showClose: true,
        message: '重启成功',
        type: 'success'
      })
    }).catch((res: any) => {
      console.error('重启失败：', res)
    }).finally(() => {
      this.loadTicketDetail()
      loadingInstance.close()
    })
  }

  assignWithPhase () {
    if (!this.selectedPhase) {
      ElMessage({
        type: 'warning',
        message: '请选择一个处理节点',
      })
      return
    }
    this.showPhaseSelectDialog = false
    this.ticketClickAssignMeWithPhaseId(this.selectedPhase)
  }

  ticketClickAssignMeWithPhaseId (phaseId: string) {
    const me = store.getters['auth/me']
    const loadingInstance = ElLoading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading'
    })
    ticketApi.ticketsAssignUpdate(this.ticket.pk, me.ldap, me.username, phaseId).then(() => {
      ElMessage({
        showClose: true,
        message: '认领成功',
        type: 'success'
      })
    }).catch((res: any) => {
      console.error('认领失败：', res)
    }).finally(() => {
      this.loadTicketDetail()
      loadingInstance.close()
      ticketApi.ticketCount().then((res: any) => {
        store.commit('updateTicketCount', res)
      })
    })
  }

  ticketClickAssignMe () {
    const me = store.getters['auth/me']
    const loadingInstance = ElLoading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading'
    })
    ticketApi.ticketsAssignUpdate(this.ticket.pk, me.ldap, me.username).then(() => {
      ElMessage({
        showClose: true,
        message: '认领成功',
        type: 'success'
      })
    }).catch((res: any) => {
      console.error('认领失败：', res)
    }).finally(() => {
      this.loadTicketDetail()
      loadingInstance.close()
    })
  }

  templateValueChange (e: any) {
    (this.$refs.templateGenerator as typeof TemplateGenerator).getData().then((data: any) => {
      const fieldInfo = deepCopy(data)
      const relationMap = deepCopy(this.currentTemplateInfo.relationMap)
      const templateRelationMap = this.currentTemplateInfo.template.fields.relationMap
      Object.keys(fieldInfo).forEach((key) => {
        const tagSetId = templateRelationMap[key].setId
        if (relationMap[tagSetId]) {
          relationMap[tagSetId].value = fieldInfo[key]
        }
      })
      const postData = {
        ticket: {
          fields: {
            fieldInfo,
            relationMap,
          }
        },
      }
      const loadingInstance = ElLoading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading'
      })
      ticketApi.updateTicket(this.ticket.pk, postData).then((res: any) => {
        console.log('updateTicket:', res)
      }, (err: any) => {
        console.error('updateTicket:', err)
      }).finally(() => {
        this.loadTicketDetail()
        loadingInstance.close()
      })
    })
  }

  displayNewline (text = '') {
    return text.replaceAll('\n', '<br>')
  }

  handleRemove (file: { name: any }) {
    const index = this.fileList.findIndex((fileInfo) => fileInfo.name === file.name)
    if (index >= 0) {
      this.fileList.splice(index, 1)
    }
  }

  handlePreview (file: any) {
    console.log(file)
  }

  uploadFile (info: { file: any }) {
    console.log('uploadFile info:', info)
    // if (this.uploading) {
    //   ElMessage({
    //     type: 'error',
    //     message: `文件 ${info.file.name} 上传失败：其他文件正在上传`
    //   })
    //   info.onError(new Error('其他文件正在上传'))
    //   return
    // }
    this.uploading = true
    const { file } = info
    const formData = new FormData()
    formData.append('file', file, file.name)
    return uploadFile(formData).then((res: { fileId: any; url: any }) => {
      console.log('上传附件', res)
      this.uploading = false
      this.fileList.push({
        name: file.name,
        key: res.fileId,
        url: res.url
      })
      console.log('fileList', this.fileList)
    }, (err: { errmsg: any }) => {
      this.uploading = false
      ElMessage({
        type: 'error',
        message: `文件 ${file.name} 上传失败：${err.errmsg}`
      })
      console.error(err)
      throw Error(`文件 ${file.name} 上传失败：${err.errmsg}`)
    })
  }

  deleteExtraTags (id: any) {
    if (this.ticket.fields.extraTags) {
      const i = this.ticket.fields.extraTags.findIndex((t: { id: any }) => t.id === id)
      if (i !== -1) {
        this.ticket.fields.extraTags.splice(i, 1)
      }
    }
  }

  ticketOr (row: { creatorName: string; creator: any }) {
    // console.log(row, 'rows')
    if (row) {
      // if (row.channel && row.channel === 5) {
      if (row.creatorName && row.creatorName !== '') {
        return row.creatorName
      } else {
        return row.creator
      }
    } else {
      return ''
    }
  }

  changeNextProcess (e: number) {
    this.loadAgentsByTag(e)
    const isLevel3 = this.processLabels.some(l => {
      return l.id === e && l.name === 'LEVEL-3'
    })
    if (isLevel3) {
      ElMessageBox.alert('请按照操作文档进行问题排查，并在问题回复中添加排查截图。', '提示', {
        confirmButtonText: '确定',
        callback: (action: any) => {
          // ElMessage({
          //   type: 'info',
          //   message: `action: ${action}`,
          // })
        },
      })
    }
  }

  formatDate (timestamp: number) {
    const two = (n: string | number) => n < 10 ? '0' + n : '' + n
    const d = new Date(timestamp * 1000)
    return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日 ${two(d.getHours())}:${two(d.getMinutes())}`
  }

  formatTimestamp (timestamp: number) {
    return timestamp * 1000
  }

  formatDate2 (timestamp: number) {
    const two = (n: string | number) => n < 10 ? '0' + n : '' + n
    const d = new Date(timestamp)
    return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日 ${two(d.getHours())}:${two(d.getMinutes())}`
  }

  formatTime (timestamp: number) {
    // let result = parseInt(timestamp)
    const result = timestamp
    var h = Math.floor(result / 3600)
    const m = Math.floor((result / 60 % 60))
    const s = Math.floor((result % 60))
    let res = ''
    if (h > 24) {
      const d = Math.floor(h / 24)
      res += `${d}天`
      h = h % 24
    }
    if (h !== 0) {
      res += `${h}小时`
    }
    if (m !== 0) {
      res += `${m}分钟`
    } else {
      res += `${s}秒`
    }
    return res
  }

  async loadAgentsByTag (tagId: number) : Promise<void> {
    this.handlers = []
    let res = await agent.agentsByTag(tagId)
    this.handlers.push(...res.results)
    while (res.next) {
      res = await agent.agentsByTag(tagId, res.page + 1)
      this.handlers.push(...res.results)
    }
  }

  async loadAgentsForJira () {
    const res = await agentsForJira()
    this.jiraHandlers = res.results
  }

  onSubmit (e: any) {
    this.ticket.fields.extraTags = e
    this.showTicketAddTag = false
  }

  ticketClose () {
    this.buttonClicked = 'close'
    const $refs = this.$refs as any
    $refs.ruleFormRef.validate((valid: any) => {
      if (valid) {
        ElMessageBox.confirm('确定已解决吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (this.ruleForm.newReply.trim().length === 0) {
            ElMessage({
              type: 'warning',
              message: '请填写问题回复'
            })
            return
          }
          const templateValueAllSelected = Object.keys(this.templateValue).every(k => !!this.templateValue[k])
          if (!templateValueAllSelected) {
            ElMessageBox.confirm('请完善左侧分类信息。', '提示', {
              confirmButtonText: '暂不完善',
              cancelButtonText: '去完善',
              type: 'warning'
            }).then((action) => {
              console.log(action)
              this.transTicket(TicketStatus.CLOSED, () => {
                this.$router.back()
              })
            }).catch((action) => {
              console.log(action)
            })
          } else {
            this.transTicket(TicketStatus.CLOSED, () => {
              this.$router.back()
            })
          }
        }).catch(() => {
          // ElMessage({
          //   type: 'info',
          //   message: '已取消操作'
          // })
        })
      }
    })
  }

  ticketDirectClose () {
    ElMessageBox.confirm('确定要直接关闭工单吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading'
      })
      const ticketId = Number(this.$route.params.id)
      ticketApi.ticketDirectClose(ticketId).then((res: any) => {
        this.loadTicketDetail()
        ElMessage({
          type: 'success',
          message: '关闭成功'
        })
      }, (err: { errmsg: any }) => {
        console.error(err)
        ElMessage({
          type: 'error',
          message: err.errmsg
        })
      }).finally(() => {
        loadingInstance.close()
      })
    }).catch(() => {
      // ElMessage({
      //   type: 'info',
      //   message: '已取消操作'
      // })
    })
  }

  async continueFormValid () {
    return new Promise((resolve, reject) => {
      this.buttonClicked = 'continue'
      const $refs = this.$refs as any
      $refs.ruleFormRef.validate((valid: any) => {
        if (valid) {
          if (!this.ruleForm.nextProcess && !this.workflowId) {
            ElMessage({
              type: 'warning',
              message: '请选择下一阶段'
            })
            reject(new Error('请选择下一阶段'))
            return
          }
          if (this.ruleForm.newReply.trim().length === 0) {
            ElMessage({
              type: 'warning',
              message: '请填写问题回复'
            })
            reject(new Error('请填写问题回复'))
            return
          }
          resolve(true)
        } else {
          reject(new Error('请检查参数'))
        }
      })
    })
  }

  // 生成jira.bug
  async ticketContJira (type: string) {
    this.contJiraType = type
    const ticketId = Number(this.$route.params.id)
    let loadingInstance = ElLoading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading'
    })
    // this.loadAgentsForJira()
    if (type === 'continueRelation') {
      try {
        await this.continueFormValid()
      } catch (e) {
        return
      } finally {
        loadingInstance.close()
      }
      loadingInstance = ElLoading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading'
      })
      const data = await (this.$refs.templateGenerator as typeof TemplateGenerator).getData()
      const fieldInfo = deepCopy(data)
      // const relationMap = deepCopy(this.ticket.fields.relationMap)
      // const templateRelationMap = this.ticket.fields.template.fields.relationMap
      const relationMap = deepCopy(this.currentTemplateInfo.relationMap)
      const templateRelationMap = this.currentTemplateInfo.template.fields.relationMap
      Object.keys(fieldInfo).forEach((key) => {
        const tagSetId = templateRelationMap[key].setId
        if (relationMap[tagSetId]) {
          relationMap[tagSetId].value = fieldInfo[key]
        }
      })
      const payload = {
        assignee: this.userName,
        ticket: {
          model: this.ticket.model,
          pk: this.ticket.pk,
          fields: {
            fieldInfo,
            relationMap,
            // curResult: 'continued',
            curStatus: this.ticket.fields.curStatus,
          }
        },
        transaction: {
          extraTags: this.ticket.fields.extraTags,
          comment: this.ruleForm.newReply,
          attachments: this.fileList,
          nextPhaseId: this.ruleForm.nextProcess || this.ticket.fields.curPhaseId,
          nextAgent: this.ruleForm.nextHandler
        },
        jiraProject: this.jiraProject ? [this.jiraProject] : null,
        errorEnv: this.errorEnv ? [this.errorEnv] : null,
      }
      postJira(payload, ticketId).then((res: { errorEnv: string | any[]; jiraProjectList: string | any[]; ldapid: null }) => {
        if (res?.errorEnv && res?.jiraProjectList && res?.errorEnv.length > 0 && res?.jiraProjectList.length > 0) {
          this.detialShowTickets = true
          // this.jiraProjectList = res?.jiraProjectList
          // this.errorEnvList = res?.errorEnv
          this.handlerJira = res?.ldapid
        } else {
          this.loadTicketDetail()
          ElMessage({
            type: 'success',
            message: '生成成功'
          })
          this.detialShowTickets = false
        }
      }, (err: { errmsg: any }) => {
        console.error(err)
        ElMessage({
          type: 'error',
          message: err.errmsg
        })
      }).finally(() => {
        loadingInstance.close()
      })
    } else if (type === 'relation') {
      this.loadAgentsForJira()
      getJiraProjectAndErrorEnv(ticketId).then((res: { jiraProjectList: never[]; errorEnv: never[] }) => {
        this.detialShowTickets = true
        this.relationJiraBtn = true
        this.jiraProjectList = res?.jiraProjectList
        this.errorEnvList = res?.errorEnv
      }, (err: { errmsg: any }) => {
        console.error(err)
        ElMessage({
          type: 'error',
          message: err.errmsg
        })
      }).finally(() => {
        loadingInstance.close()
      })
    }
  }

  ticketRelationJira () {
    const loadingInstance = ElLoading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading'
    })
    const payload = {
      assignee: this.handlerJira,
      jiraProject: this.jiraProject ? this.jiraProject : null,
      errorEnv: this.errorEnv ? [this.errorEnv] : null,
    }
    const ticketId = Number(this.$route.params.id)
    ticketRelationJira(payload, ticketId).then((res: any) => {
      this.loadTicketDetail()
      ElMessage({
        type: 'success',
        message: '生成成功'
      })
      this.detialShowTickets = false
      this.relationJiraBtn = false
    }, (err: { errmsg: any }) => {
      console.error(err)
      ElMessage({
        type: 'error',
        message: err.errmsg
      })
    }).finally(() => {
      loadingInstance.close()
    })
  }

  ticketContinue () {
    this.buttonClicked = 'continue'
    const $refs = this.$refs as any
    $refs.ruleFormRef.validate((valid: any) => {
      if (valid) {
        if (!this.ruleForm.nextProcess && !this.workflowId) {
          ElMessage({
            type: 'warning',
            message: '请选择下一阶段'
          })
          return
        }
        if (this.ruleForm.newReply.trim().length === 0) {
          ElMessage({
            type: 'warning',
            message: '请填写问题回复'
          })
          return
        }
        this.transTicket(TicketStatus.PENDING, () => {
          console.log('continue success')
        })
      }
    })
  }

  delayedProcess () {
    if (this.ruleForm.newReply.trim().length === 0) {
      return ElMessage({
        type: 'warning',
        message: '请填写问题回复'
      })
    }
    const loadingInstance = ElLoading.service({
      lock: true,
      text: '工单挂起中...',
      spinner: 'el-icon-loading'
    })
    const postData = {
      transaction: {
        extraTags: this.ticket.fields.extraTags,
        comment: this.ruleForm.newReply,
        attachments: this.fileList,
        nextPhaseId: this.ticket.fields.curPhaseId ? (this.ruleForm.nextProcess || this.ticket.fields.curPhaseId) : this.selectedPhase,
        nextAgent: this.ruleForm.nextHandler
      }
    }
    ticketApi.ticketsSuspend(this.ticket.pk, postData).then((res: any) => {
      this.ruleForm.newReply = ''
    }, (err: { errmsg: any }) => {
      ElMessage({
        type: 'error',
        message: err.errmsg
      })
    }).finally(() => {
      this.loadTicketDetail()
      loadingInstance.close()
    })
  }

  transTicket (ticketStatus: TicketStatus, callback: () => void) {
    (this.$refs.templateGenerator as typeof TemplateGenerator).getData().then((data: any) => {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading'
      })
      const fieldInfo = deepCopy(data)
      // const relationMap = deepCopy(this.ticket.fields.relationMap)
      // const templateRelationMap = this.ticket.fields.template.fields.relationMap
      const relationMap = deepCopy(this.currentTemplateInfo.relationMap)
      const templateRelationMap = this.currentTemplateInfo.template.fields.relationMap
      Object.keys(fieldInfo).forEach((key) => {
        const tagSetId = templateRelationMap[key].setId
        if (relationMap[tagSetId]) {
          relationMap[tagSetId].value = fieldInfo[key]
        }
      })
      const postData = {
        ticket: {
          model: this.ticket.model,
          pk: this.ticket.pk,
          fields: {
            fieldInfo,
            relationMap,
            // curResult: 'continued',
            curStatus: ticketStatus
          }
        },
        transaction: {
          extraTags: this.ticket.fields.extraTags,
          comment: this.ruleForm.newReply,
          attachments: this.fileList,
          nextPhaseId: this.ruleForm.nextProcess || this.ticket.fields.curPhaseId,
          nextAgent: this.ruleForm.nextHandler,
          selectedPhaseId: this.workflowId ? this.selectedPhase : undefined,
          taskVariables: Object.keys(this.taskVariables).length > 0 ? this.taskVariables : undefined,
        }
      }
      ticketApi.transTicket(this.ticket.pk, postData).then((res: any) => {
        this.loadTicketDetail()
        const fu = this.$refs.fileUploader as any
        fu.clearFiles()
        this.ruleForm.newReply = ''
        callback()
      }, (err: any) => {
        console.error(err)
      }).finally(() => {
        loadingInstance.close()
      })
    })
  }

  loadTicketDetail () {
    const id = Number(this.$route.params.id)
    ticketApi.ticketDetail(id).then((res: { ticket: Record<string, any>; transactions: any }) => {
      const list = res.ticket.fields?.templateList || []
      this.templateUsedRecord = list.filter((t: { isCurrent: any }) => !t.isCurrent)
      this.currentTemplateInfo = list.filter((t: { isCurrent: any }) => t.isCurrent)[0]
      // console.log('currentTemplateInfo', this.currentTemplateInfo)
      this.template = this.currentTemplateInfo.template?.fields?.template
      this.templateValue = this.currentTemplateInfo.fieldInfo
      // this.template = res.ticket.fields.template.fields.template
      // this.templateValue = res.ticket.fields.fieldInfo
      this.ticket = res.ticket
      if (!this.ticket.fields?.curPhaseId) {
        this.workflowId = res.ticket.fields?.workflow?.wfId
        this.workflowName = res.ticket.fields?.workflow?.wfName
        this.workflowDiagram = res.ticket.fields?.workflow?.wfDiagram
        this.workflowDiagramList.push(this.workflowDiagram)
        this.processablePhases = res.ticket.fields?.processablePhases
        this.claimablePhases = res.ticket.fields?.claimablePhases
        this.planTime = { start: res.ticket.fields?.workflow?.wfPlan?.start && res.ticket.fields?.workflow?.wfPlan?.start * 1000, end: res.ticket.fields?.workflow?.wfPlan?.end && res.ticket.fields?.workflow?.wfPlan?.end * 1000 }
        this.milestoneList = res.ticket.fields?.workflow?.wfMilestone?.length ? res.ticket.fields?.workflow?.wfMilestone?.map((i: { time: number }) => ({ ...i, time: i.time ? i.time * 1000 : null })) : []
        this.selectedPhase = this.processablePhases[0]?.phaseId
        this.taskVariables = this.processablePhases[0]?.taskVariables || {}
      }
      this.transactions = deepCopy(res.transactions) || []
      this.transactions2 = deepCopy(res.transactions) || []
      this.transactions2 = this.transactions2.slice(1)

      for (const tx of this.transactions2) {
        tx.createdAt = tx.createdAt * 1000
      }
      this.problemId = res.ticket.fields.problemId
      // this.ticket.fields.problem.fields.createTime = this.ticket.fields?.problem?.fields?.createTime && this.ticket.fields?.problem?.fields?.createTime * 1000
      this.problemCreateTime = this.ticket.fields?.problem?.fields?.createTime && this.ticket.fields?.problem?.fields?.createTime * 1000
      this.ticketCreateTime = this.ticket.fields?.createdAt && this.ticket.fields?.createdAt * 1000
    }).catch((res: any) => {
      console.error(res)
    })
  }

  checkImage (filename: any) {
    return checkImage(filename)
  }

  imageList (filelist: any[]) {
    return filelist.filter((file: { name: any }) => checkImage(file.name))
  }

  notImageList (filelist: any[]) {
    return filelist.filter((file: { name: any }) => !checkImage(file.name))
  }

  hideFilterBox (e: { target: { closest: (arg0: string) => any } }) {
    if (e.target.closest('.detial-show-tickets') || e.target.closest('.jira-class')) {
      return false
    }
    this.detialShowTickets = false
    this.relationJiraBtn = false
  }

  beforeUnmount () {
    // window.removeEventListener('click', this.hideFilterBox)
  }

  mounted () {
    this.loadTicketDetail()
    const user = store.getters['auth/me']
    this.userName = user.username
    // window.addEventListener('click', this.hideFilterBox)
    label.processLabels().then((res: any[]) => {
      this.processLabels = res.filter((l: { isDeleted: any }) => !l.isDeleted)
    }).catch((res: any) => [
      console.log('processLabels error:', res)
    ])
    selfTags(this.me.ldap).then((res: string[]) => {
      this.selfTagList = res
    }).catch((res: any) => {
      console.error(res)
    })
  }
}
